var render = function render(){var _vm=this,_c=_vm._self._c;return _c('organization-detail',{attrs:{"organization":_vm.$auth.me.organization},on:{"updated":_vm.updated}})
}
var staticRenderFns = []

export { render, staticRenderFns }